import React from "react";
import { CustomIconButton, CustomTooltip, icon } from "..";
import { POSITIONS_STATUSES } from "../../constants/positions-statuses";
import { translateEnumStatus } from "../../providers";
import styles from "./PositionIcon.module.css";

const STATUS_ICONS = {
	[POSITIONS_STATUSES.YES]: icon.faCheckCircle,
	[POSITIONS_STATUSES.NO]: icon.faTimesCircle,
	[POSITIONS_STATUSES.PENDING]: icon.faClock,
	[POSITIONS_STATUSES.NOT_ME]: icon.aitNotEqualsCircle,
	[POSITIONS_STATUSES.UNREVIEWED]: icon.aitHourglassCircle,
};

const ICONS_COLORS = {
	[POSITIONS_STATUSES.YES]: "var(--lime-500)",
	[POSITIONS_STATUSES.NO]: "var(--red-500)",
	[POSITIONS_STATUSES.PENDING]: "var(--amber-500)",
	[POSITIONS_STATUSES.NOT_ME]: "var(--color-black)",
	[POSITIONS_STATUSES.UNREVIEWED]: "var(--grey-500)",
};

export default function PositionIcon({
	active = true,
	clickable = false,
	onClick,
	positionsStatus = POSITIONS_STATUSES.UNREVIEWED,
	selectedExist = false,
}) {
	const handleClick = () => {
		if (typeof onClick === "function" && clickable) {
			onClick();
		}
	};
	return (
		<CustomTooltip placement="top" title={translateEnumStatus(positionsStatus?.toLowerCase().replaceAll("_", "-"))}>
			<CustomIconButton
				btnClassName={`${styles.button} ${!clickable ? styles["button--not-clickable"] : ""}`}
				className={styles.buttonWrapper}
				data-active={active}
				data-positionstatus={positionsStatus}
				data-selectedexist={selectedExist}
				icon={STATUS_ICONS[positionsStatus]}
				iconColor={ICONS_COLORS[positionsStatus]}
				onClick={handleClick}
			/>
		</CustomTooltip>
	);
}
